import {
  distributeObjects,
  GenerateSidebar,
  SubdomainOrgIdObject,
} from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { TSLandingPage } from "../components/TSLandingPage";
import { GroupAccessTool } from "../features/admin-menu/group-management/GroupAccessTool";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSuitcase } from "@fortawesome/free-solid-svg-icons";

const orgId: number = 1270257552;
const subDomain: string = "kindlending";
const nameOfProduct: string = "KL";
const secureRouteGroups: string[] = [];
const editableRightsGroup: string = "KINDLENDINGEDITINGRIGHTS";
const groupToolAccessGroup: string = "KINDLENDINGGROUPTOOLACCESS";

export const kindLendingObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  externalInfo: { subdomain: "kindlending", productURL: "kindlending" },
  editableRightsGroup: editableRightsGroup,
};

const corporateLiveboardObjects = [
  {
    title: "CEO Dashboard",
    description: "",
    link: "pinboard/d7073c15-b359-40dc-9a1d-6bd198db56b1",
  },
];

const operationsLiveboardObjects = [
  {
    title: "Wholesale Ops Pipeline Reporting",
    description: "",
    link: "pinboard/4f2122ea-3272-4f21-8f3e-8394016f16f0",
  },
];

const productionLiveboardObjects = [
  {
    title: "Retail Sales",
    description: "",
    link: "pinboard/a188ad85-86bd-4ff9-8da7-2fff0d3ff185",
  },
  {
    title: "Wholesale Sales",
    description: "",
    link: "pinboard/6e3d6413-4c59-4b94-af51-6588fef83f52",
  },
];

const sidebarMenu = () => {
  return (
    <>
      <GenerateSidebar
        productTitle="Kind Lending"
        subDomainURL={subDomain}
        staticLandingPageObjects={[
          { title: "Corporate", liveboardArray: corporateLiveboardObjects },
          { title: "Operations", liveboardArray: operationsLiveboardObjects },
          { title: "Production", liveboardArray: productionLiveboardObjects },
        ]}
        otherObjects={{
          sidebarElement: (
            <MenuItem>
              <Link to={`/${subDomain}/group-access`}>
                <div className="sidebar-item">
                  <FontAwesomeIcon className="me-2" icon={faSuitcase} />
                  Group Access
                </div>
              </Link>
            </MenuItem>
          ),
          groupPermission: groupToolAccessGroup,
        }}
      />
    </>
  );
};

const KindLendingLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Corporate",
          description: "",
          link: `/${subDomain}/corporate`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Operations",
          description: "",
          link: `/${subDomain}/operations`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Production",
          description: "",
          link: `/${subDomain}/production`,
          internal: true,
          overrideParentURL: true,
        },
      ],
    ]}
  />
);

const KindLendingCorporateLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomain}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      ...distributeObjects(corporateLiveboardObjects, 3),
    ]}
  />
);

const KindLendingOperationsLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomain}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      ...distributeObjects(operationsLiveboardObjects, 3),
    ]}
  />
);

const KindLendingProductionLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomain}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      ...distributeObjects(productionLiveboardObjects, 3),
    ]}
  />
);

export const kindLendingRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={KindLendingLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/operations`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={KindLendingOperationsLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/production`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={KindLendingProductionLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/corporate`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={KindLendingCorporateLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={kindLendingObject}
              disableEditButtonArray={[]}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/group-access`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<GroupAccessTool enableDescriptions={false} orgId={kindLendingObject.orgID} />}
          groups={[groupToolAccessGroup]}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
